// extracted by mini-css-extract-plugin
module.exports = {"floating_label":"floating_label_floating_label__4mauf","floating_label_shrink":"floating_label_floating_label_shrink__gSccv"};